export default {
  // Home page, basic <title> and <description>
  appName: 'Zocial',
  appDescription: 'Ein minimalistischer, eigenwilliger Mastodon Webclient.',
  homeDescription: `
    <p>
      Ein minimalistischer, eigenwilliger Mastodon Webclient.
    </p>`,
  homeMultiInstance: `
    <p>
      Melde dich bei einer Instanz an, um loszulegen:
    </p>`,
  logIn: 'Anmelden',
  footer: `
    <p>
      Powered by <a rel="noopener" target="_blank" href="https://ztfr.eu">Zeitfresser</a> · <a href="/settings/about#donations" rel="prefetch">Donations</a> · <a href="/settings/about#privacy-policy" rel="prefetch">Privacy Policy</a> · <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/releases">Zocial v{version}</a>
    </p>
  `,
  // Generic UI
  newStatus: 'Neuer Beitrag',
  loading: 'Wird geladen',
  okay: 'OK',
  cancel: 'Abbrechen',
  alert: 'Hinweis',
  close: 'Schließen',
  error: 'Fehler: {error}',
  errorShort: 'Fehler:',
  account: 'Account',
  start: 'Start',
  stop: 'Stop',
  // Relative timestamps
  justNow: 'gerade eben',
  // Navigation, page titles
  navItemLabel: `
    {label} {selected, select,
      true {(aktuelle Seite)}
      other {}
    } {name, select,
      notifications {{count, plural,
        =0 {}
        one {(eine Benachrichtigung)}
        other {({count} Benachrichtigungen)}
      }}
      community {{count, plural,
        =0 {}
        one {(eine Followeranfrage)}
        other {({count} Followeranfragen)}
      }}
      other {}
    }
  `,
  blockedUsers: 'Blockierte Benutzer',
  bookmarks: 'Lesezeichen',
  directMessages: 'Direktnachrichten',
  favorites: 'Favoriten',
  reactions: 'Reaktionen',
  federated: 'Föderiert',
  bubble: 'Bubble',
  home: 'Startseite',
  local: 'Lokal',
  notifications: 'Benachrichtigungen',
  mutedUsers: 'Stummgeschaltete Benutzer',
  pinnedStatuses: 'Angeheftete Beiträge',
  followRequests: 'Followeranfragen',
  followRequestsLabel: `Followeranfragen {hasFollowRequests, select,
    true {({count})}
    other {}
  }`,
  list: 'Liste',
  search: 'Suchen',
  pageHeader: 'Seitenkopf',
  goBack: 'Zurückgehen',
  back: 'Zurück',
  profile: 'Profil',
  federatedTimeline: 'Föderierte Zeitleiste',
  bubbleTimeline: 'Bubble-Zeitleiste',
  localTimeline: 'Lokale Zeitleiste',
  // community page
  community: 'Community',
  pinnableTimelines: 'Zeitleisten, die angeheftet werden können',
  timelines: 'Zeitleisten',
  lists: 'Listen',
  instanceSettings: 'Einstellungen der Instanz',
  notificationMentions: 'Benachrichtigungen über Erwähnungen',
  profileWithMedia: 'Profil mit Medien',
  profileWithReplies: 'Profil mit Antworten',
  hashtag: 'Hashtag',
  // not logged in
  profileNotLoggedIn: 'Hier erscheint Deine Benutzerzeitleiste, wenn Du Dich anmeldest.',
  bookmarksNotLoggedIn: 'Hier erscheinen Deine Lesezeichen, wenn Du Dich anmeldest.',
  directMessagesNotLoggedIn: 'Hier erscheinen Deine Direktnachrichten, wenn Du Dich anmeldest.',
  favoritesNotLoggedIn: 'Hier erscheinen Deine Favoriten, wenn Du Dich anmeldest.',
  federatedTimelineNotLoggedIn: 'Hier erscheint Deine föderierte Zeitleiste, wenn Du Dich anmeldest.',
  localTimelineNotLoggedIn: 'Hier erscheint Deine lokale Zeitleiste, wenn Du Dich anmeldest.',
  searchNotLoggedIn: 'Du kannst eine Suche ausführen, sobald Du bei einer Instanz angemeldet bist.',
  communityNotLoggedIn: 'Hier erscheinen Community-Optionen, wenn Du Dich anmeldest.',
  listNotLoggedIn: 'Hier erscheint eine Liste, wenn Du Dich anmeldest.',
  notificationsNotLoggedIn: 'Hier erscheinen Deine Benachrichtigungen, wenn Du Dich anmeldest.',
  notificationMentionsNotLoggedIn: 'Hier erscheinen Deine Benachrichtigungen zu Erwähnungen, wenn Du Dich anmeldest.',
  statusNotLoggedIn: 'Hier erscheint der Faden zu einem Beitrag, wenn Du Dich anmeldest.',
  tagNotLoggedIn: 'Hier erscheinen Beiträge zu einem hashtag, wenn Du Dich anmeldest.',
  bubbleTimelineNotLoggedIn: 'Deine Bubble-Zeitleiste erscheint hier, sobald Du angemeldet bist.',
  bubbleTimelineNotSupported: 'Die Bubble-Zeitleiste wird von Deiner Instanz nicht unterstützt.',
  accountNotLoggedIn: 'Die Account-Einstellungen erscheinen hier, sobald Du angemeldet bist.',
  filtered: 'Gefiltert',
  // Notification subpages
  filters: 'Filter',
  all: 'Alle',
  mentions: 'Erwähnungen',
  // Follow requests
  approve: 'Genehmigen',
  reject: 'Ablehnen',
  // Hotkeys
  hotkeys: 'Tastenkürzel',
  global: 'Global',
  timeline: 'Zeitleiste',
  media: 'Medien',
  globalHotkeys: `
    {leftRightChangesFocus, select,
      true {
        <li><kbd>→</kbd> gehe zum nächsten fokussierbaren Element</li>
        <li><kbd>←</kbd> gehe zum vorherigen fokussierbaren Element</li>
      }
      other {}
    }
    <li>
      <kbd>1</kbd> - <kbd>6</kbd>
      {leftRightChangesFocus, select,
        true {}
        other {oder <kbd>←</kbd>/<kbd>→</kbd>}
      }
      um die Spalten umzuschalten
    </li>
    <li><kbd>7</kbd> oder <kbd>c</kbd> zum Erstellen eines neuen Beitrags</li>
    <li><kbd>s</kbd> oder <kbd>/</kbd> zum Suchen</li>
    <li><kbd>g</kbd> + <kbd>h</kbd> zur Startseite gehen</li>
    <li><kbd>g</kbd> + <kbd>n</kbd> zu den Benachrichtigungen gehen</li>
    <li><kbd>g</kbd> + <kbd>l</kbd> zur lokalen Zeitleiste gehen</li>
    <li><kbd>g</kbd> + <kbd>b</kbd> zur Bubble-Zeitleiste gehen</li>
    <li><kbd>g</kbd> + <kbd>t</kbd> zur föderierten Zeitleiste gehen</li>
    <li><kbd>g</kbd> + <kbd>c</kbd> zur Community-Seite gehen</li>
    <li><kbd>g</kbd> + <kbd>d</kbd> zur Seite mit Direktnachrichten gehen</li>
    <li><kbd>g</kbd> + <kbd>i</kbd> zur Instanzen-Seite gehen</li>
    <li><kbd>h</kbd> oder <kbd>?</kbd> zum Umschalten des Hilfe-Dialogs</li>
    <li><kbd>Rückschritttaste</kbd> zurückgehen, Dialogfelder schließen</li>
  `,
  timelineHotkeys: `
    <li><kbd>j</kbd> oder <kbd>↓</kbd> nächsten Beitrag ansteuern</li>
    <li><kbd>k</kbd> oder <kbd>↑</kbd> vorherigen Beitrag ansteuern</li>
    <li><kbd>.</kbd> neue Beiträge anzeigen und nach oben scrollen</li>
    <li><kbd>o</kbd> Beitrag öffnen</li>
    <li><kbd>f</kbd> Beitrag favorisieren</li>
    <li><kbd>b</kbd> Beitrag boosten</li>
    <li><kbd>r</kbd> auf Beitrag antworten</li>
    <li><kbd>e</kbd> eigene Beiträge bearbeiten</li>
    <li><kbd>q</kbd> einen Beitrag zitieren, falls unterstützt</li>
    <li><kbd>Escape</kbd> Antwort schließen</li>
    <li><kbd>a</kbd> mit Lesezeichen versehen</li>
    <li><kbd>i</kbd> Bilder, Videos oder Audio öffnen</li>
    <li><kbd>y</kbd> sensible Medieninhalte zeigen oder verbergen</li>
    <li><kbd>m</kbd> den Verfasser erwähnen</li>
    <li><kbd>p</kbd> das Profil des Verfassers öffnen</li>
    <li><kbd>l</kbd> den Link der Karte in einem neuen Tab öffnen</li>
    <li><kbd>x</kbd> den Text hinter der Inhaltswarnung anzeigen oder verbergen</li>
    <li><kbd>z</kbd> alle Inhaltswarnungen in einer Unterhaltung anzeigen oder verbergen</li>
    <li><kbd>t</kbd> einen Beitrag übersetzen</li>
  `,
  mediaHotkeys: `
    <li><kbd>←</kbd> / <kbd>→</kbd> zum nächsten oder vorherigen Inhalt gehen</li>
  `,
  // Community page, tabs
  tabLabel: `{label} {current, select,
    true {(Aktuell)}
    other {}
  }`,
  pageTitle: `
    {hasNotifications, select,
      true {({count})}
      other {}
    }
    {name}
    ·
    {showInstanceName, select,
      true {{instanceName}}
      other {{appName}}
    }
  `,
  pinLabel: `{label} {pinnable, select,
    true {
      {pinned, select,
        true {(Angeheftete Seite)}
        other {(Nicht angeheftete Seite)}
      }
    }
    other {}
  }`,
  pinPage: 'Hefte {label} an',
  // Status composition
  composeStatus: 'Beitrag erstellen',
  postStatus: 'Post',
  contentWarning: 'Inhaltswarnung',
  dropToUpload: 'Fallenlassen zum Hochladen',
  invalidFileType: 'Ungültiger Dateityp',
  composeLabel: "Was gibt's Neues?",
  autocompleteDescription: 'Autovervollständigungsergebnisse verfügbar. Drücke die Pfeiltasten auf und ab und dann Eingabe zum Auswählen.',
  mediaUploads: 'Medien-Uploads',
  edit: 'Bearbeiten',
  delete: 'Löschen',
  description: 'Beschreibung',
  descriptionLabel: 'Beschreibe Bilder oder Videos für Menschen mit Seheinschränkungen, oder Audio- oder Videoinhalte für Menschen mit Höreinschränkungen',
  markAsSensitive: 'Medien als sensibel kennzeichnen',
  // Polls
  createPoll: 'Umfrage erstellen',
  removePollChoice: 'Auswahl {index} entfernen',
  pollChoiceLabel: 'Auswahl {index}',
  multipleChoice: 'Mehrfachauswahl',
  pollDuration: 'Dauer der Umfrage',
  fiveMinutes: '5 Minuten',
  thirtyMinutes: '30 Minuten',
  twelveHours: '12 Stunden',
  fourteenDays: '14 Tage',
  thirtyDays: '30 Tage',
  oneYear: '1 Jahr',
  never: 'Nie',
  schedulePost: 'Beitrag planen',
  removeSchedule: 'Planung entfernen',
  scheduleSet: 'Planen',
  oneHour: '1 Stunde',
  sixHours: '6 Stunden',
  oneDay: '1 Tag',
  threeDays: '3 Tage',
  sevenDays: '7 Tage',
  addEmoji: 'Emoji einfügen',
  addMedia: 'Medien einfügen (Bilder, video, audio)',
  addPoll: 'Umfrage hinzufügen',
  removePoll: 'Umfrage entfernen',
  postPrivacyLabel: 'Privatsphäre anpassen (aktuell {label})',
  addContentWarning: 'Inhaltswarnung hinzufügen',
  removeContentWarning: 'Inhaltswarnung entfernen',
  altLabel: 'Beschreibe für Menschen mit Seheinschränkungen',
  extractText: 'Text aus Bild ermitteln',
  extractingText: 'Erkenne Text',
  scheduleDateTimeLabel: 'Senden um',
  scheduleTooSoon: 'Die geplante Zeit muss mindestens 5 Minuten in der Zukunft liegen',
  scheduledStatusCreated: 'Beitrag geplant',
  scheduledPosts: 'Geplante Beiträge',
  noScheduledPosts: 'Keine geplanten Beiträge',
  cancelScheduledPost: 'Abbrechen',
  rescheduleLabel: 'Neu planen',
  scheduledPostCancelled: 'Geplanter Beitrag abgebrochen',
  scheduledPostRescheduled: 'Neu geplant',
  youVotedFor: 'Du hast abgestimmt für',
  backfill: 'Fehlende Beiträge laden',
  createList: 'Liste erstellen',
  unableToCreateList: 'Liste konnte nicht erstellt werden: {error}',
  listTitle: 'Listentitel',
  manageLists: 'Listen verwalten',
  rename: 'Umbenennen',
  listExclusive: 'Beiträge nur in dieser Liste anzeigen',
  listExclusiveHelp: 'Mitglieder dieser Liste erscheinen nicht in deiner Home-Timeline.',
  listExclusiveNotSupported: 'Dieser Server unterstützt exklusive Listen nicht.',
  deleteListTitle: '„{title}“ löschen?',
  deleteListConfirm: 'Dies löscht die Liste „{title}“. Die enthaltenen Konten sind nicht betroffen; war sie exklusiv, erscheinen ihre Beiträge wieder in deiner Home-Timeline.',
  deletedList: 'Liste gelöscht.',
  unableToRenameList: 'Liste konnte nicht umbenannt werden: {error}',
  unableToUpdateList: 'Liste konnte nicht aktualisiert werden: {error}',
  unableToDeleteList: 'Liste konnte nicht gelöscht werden: {error}',
  extractingTextCompletion: 'Erkenne Text ({percent}% abgeschlossen)…',
  unableToExtractText: 'Es konnte kein Text erkannt werden.',
  // Account options
  followAccount: 'Folge {account}',
  unfollowAccount: 'Entfolge {account}',
  blockAccount: 'Blockiere {account}',
  unblockAccount: 'Blockieren von {account} aufheben',
  muteAccount: 'Schalte {account} stumm',
  unmuteAccount: 'Hebe Stummschaltung von {account} auf',
  showReblogsFromAccount: 'Boosts von {account} anzeigen',
  hideReblogsFromAccount: 'Boosts von {account} verbergen',
  showDomain: 'Verbergen von {domain} aufheben',
  hideDomain: 'Verbirg {domain}',
  manageInLists: 'Listenmitgliedschaften verwalten',
  listMembership: 'Listenmitgliedschaften für {account}',
  noListsYet: 'Noch keine Listen',
  errorInListMembership: 'Fehler beim Aktualisieren der Listenmitgliedschaft',
  listMembershipNotSupported: 'Wird von diesem Server nicht unterstützt',
  reportAccount: 'Melde {account}',
  mentionAccount: 'Erwähne {account}',
  copyLinkToAccount: 'Kopiere Link zu account',
  copiedToClipboard: 'In Zwischenablage kopiert',
  // Media dialog
  navigateMedia: 'Durch Medieninhalte navigieren',
  showPreviousMedia: 'Vorherigen Medieninhalt zeigen',
  showNextMedia: 'Nächsten Medieninhalt zeigen',
  enterPinchZoom: 'Modus Ziehen zum Zoomen',
  exitPinchZoom: 'Modus Ziehen zum Zoomen beenden',
  showMedia: `Zeige {index, select,
    1 {ersten}
    2 {zweiten}
    3 {dritten}
    other {vierten}
  } Medieninhalt {current, select,
    true {(aktuell)}
    other {}
  }`,
  previewFocalPoint: 'Vorschau (Hauptausschnitt)',
  enterFocalPoint: 'Koordinaten des Hauptausschnitts des Medieninhalts eingeben (X, Y)',
  muteNotifications: 'Auch Benachrichtigungen stummschalten',
  muteAccountConfirm: '{account} stummschalten?',
  mute: 'Stummschalten',
  unmute: 'Stummschaltung aufheben',
  zoomOut: 'Herauszoomen',
  zoomIn: 'Hineinzoomen',
  // Reporting
  reportingLabel: 'Du machst eine Meldung von {account} an die Moderatoren von {instance}.',
  additionalComments: 'Zusätzliche Kommentare',
  forwardDescription: 'Auch an die Moderatoren von {instance} weiterleiten?',
  forwardLabel: 'An {instance} weiterleiten',
  unableToLoadStatuses: 'Kann neueste Beiträge nicht laden: {error}',
  report: 'Melden',
  noContent: '(Keine Inhalte)',
  noStatuses: 'Keine Beiträge zum Melden vorhanden',
  // Status options
  unpinFromProfile: 'Vom Profil abheften',
  pinToProfile: 'An Profil anheften',
  muteConversation: 'Unterhaltung stummschalten',
  unmuteConversation: 'Stummschaltung der Unterhaltung aufheben',
  bookmarkStatus: 'Beitrag als Lesezeichen speichern',
  unbookmarkStatus: 'Beitrag aus Lesezeichen entfernen',
  deleteAndRedraft: 'Löschen und neu eingeben',
  reportStatus: 'Beitrag melden',
  shareStatus: 'Beitrag teilen',
  copyLinkToStatus: 'Link zum Beitrag kopieren',
  // Account profile
  profileForAccount: 'Profil für {account}',
  statisticsAndMoreOptions: 'Statistiken und weitere Optionen',
  statuses: 'Beiträge',
  joined: 'Beigetreten',
  postingStatsSummary: 'Letzte {posts} in den letzten {duration}',
  postingStatsPosts: `{total, plural, one {# Beitrag} other {# Beiträge}}`,
  postingStatsDays: `{days, plural, one {# Tag} other {# Tage}}`,
  postingStatsYears: `{years, plural, one {# Jahr} other {# Jahre}}`,
  postingStatsOriginal: 'Original',
  postingStatsReplies: 'Antworten',
  postingStatsBoosts: 'Boosts',
  follows: 'Folgt',
  followers: 'Folgende',
  moreOptions: 'Weitere Optionen',
  followersLabel: 'Gefolgt von {count}',
  followingLabel: 'Folgt {count}',
  followLabel: `Folgen {requested, select,
    true {(Followeranfrage gestellt)}
    other {}
  }`,
  unfollowLabel: `Entfolgen {requested, select,
    true {(Followeranfrage gestellt)}
    other {}
  }`,
  unrequestLabel: 'Anfrage abbrechen',
  unfollowingLabel: 'Entfolgen...',
  unblockingLabel: 'Blockierung aufheben...',
  unrequestingLabel: 'Abbrechen...',
  unblock: 'Blockade aufheben',
  nameAndFollowing: 'Name und folgt',
  clickToSeeAvatar: 'Klicke zum Anzeigen des Avatars',
  opensInNewWindow: '{label} (öffnet in neuem Fenster)',
  blocked: 'Blockiert',
  domainHidden: 'Domain verborgen',
  muted: 'Stummgeschaltet',
  followsYou: 'Folgt Dir',
  locked: 'Dieses Konto ist gesperrt. Der Inhaber prüft manuell, wer ihm folgen darf.',
  scrollToTopOfConversation: 'Zum Anfang der Unterhaltung scrollen',
  scrollToTop: 'Nach oben scrollen',
  notify: 'Abonnieren von {account}',
  denotify: 'Abbestellen von {account}',
  avatarForAccount: 'Avatar für {account}',
  fields: 'Felder',
  accountHasMoved: '{account} ist umgezogen:',
  profilePageForAccount: 'Profilseite für {account}',
  verified: 'Verified',
  // About page
  about: 'Über',
  aboutApp: 'Über Zocial',
  aboutAppDescription: `
  <p>
    Zocial ist <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial">Open-Source-Software</a> und ein Fork von <a rel="noopener" target="_blank" href="https://github.com/enafore/enafore">Enafore</a>, erstellt von <a rel="noopener" target="_blank" href="https://social.ztfr.eu/@dome">Dome</a>.
  </p>

  <h2 id="privacy-policy">Datenschutzrichtlinie</h2>

  <p>
    Zocial speichert keine personenbezogenen Daten auf seinen Servern, einschließlich, aber nicht beschränkt auf Namen, E-Mail-Adressen, IP-Adressen, Beiträge und Fotos.
  </p>

  <p>
    Zocial ist eine statische Website, die überall gehostet werden kann (z. B. GitHub Pages). Sie wird als <a rel="noopener" target="_blank" href="https://hub.docker.com/r/domoel/zocial">Docker Image</a> bereitgestellt und kann mithilfe eines Nginx-Webservers aufgesetzt werden. Alle Daten werden lokal in deinem Browser gespeichert und mit den Fediverse-Instanzen geteilt, mit denen du dich verbindest.
  </p>

  <h2>Übersetzungen</h2>

  <p>
    Die Übersetzung von Beiträgen basiert auf <a rel="noopener" target="_blank" href="https://libretranslate.com">LibreTranslate</a> — einer Open-Source-Übersetzungsengine ohne Google-Abhängigkeit. Anfragen werden serverseitig weitergeleitet, sodass kein Übersetzungsdienst direkt aus deinem Browser kontaktiert wird. Self-Hosting wird über die Umgebungsvariable <code>TRANSLATE_API</code> unterstützt.
  </p>

  <h2>Einsatz von KI</h2>

  <p>
    Dieses Projekt wird KI-unterstützt entwickelt. Die Entwicklung folgt jedoch einer strengen <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/docs/Architecture.md">Design-Philosophie</a> und strikten Programmierprinzipien, und bei der Umsetzung neuer Funktionen wird mit großer Sorgfalt vorgegangen. Der Code wird regelmäßig überprüft.
  </p>

  <h2>Credits</h2>

  <p>
    Icons bereitgestellt von <a rel="noopener" target="_blank" href="http://fontawesome.io/">Font Awesome</a>.
  </p>

  <h2>Lizenz</h2>

  <p>
    Zocial ist unter der <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/LICENSE">GNU Affero General Public License</a> lizenziert. Ein <a rel="noopener" target="_blank" href="https://ztfr.eu/">Zeitfresser</a> Angebot.
  </p>

  <h2 id="donations">Spenden</h2>

  <p>
    Zocial ist ein nicht-kommerzielles Projekt und kostenlos nutzbar. Spenden sind völlig optional – sie helfen lediglich, die laufenden Kosten der öffentlichen Instanz (Domain und Hosting) zu decken.
  </p>

  <p>
    Wenn du das Projekt unterstützen möchtest: <a rel="noopener" target="_blank" href="https://www.paypal.com/donate/?hosted_button_id=QMWFH4FDXN66C">Per PayPal spenden</a>.
  </p>

  <h2>Support &amp; Entwicklung</h2>

  <p>
    Im <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/docs/User-Guide.md">Benutzerhandbuch</a> findest du allgemeine Hinweise zur Nutzung, im <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/docs/Admin-Guide.md">Admin-Handbuch</a> Hilfe, falls deine Instanz Verbindungsprobleme hat. Wenn du die zugrunde liegende Architektur und die Designentscheidungen hinter Zocial verstehen möchtest, wirf einen Blick ins <a rel="noopener" target="_blank" href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/docs/Architecture.md">Architektur-Handbuch</a>.
  </p>

  <p>
    Für weiteren Support oder zur Mitarbeit an der Entwicklung tritt der <a rel="noopener" target="_blank" href="https://ztfr.eu/matrix">Zeitfresser Matrix Community</a> oder dem <a rel="noopener" target="_blank" href="https://look.ztfr.eu/#/#support:ztfr.eu">Development &amp; Support Channel</a> bei.
  </p>

  <h2>Version</h2>

  <p>
    Du nutzt Zocial-Version <code class="zocial-version"></code>.
  </p>`,
  logs: 'Protokolle',
  showAllLogs: 'Alle Protokolle anzeigen (Debug & Info)',
  showAllLogsHint: 'Standardmäßig werden nur Warnungen und Fehler angezeigt. Aktiviere dies, um auch Debug- und Info-Protokolle einzuschließen.',
  copyLogs: 'Protokolle kopieren',
  logsCopied: 'Protokolle in die Zwischenablage kopiert',
  logsCopyFailed: 'Protokolle konnten nicht kopiert werden',
  // Settings
  settings: 'Einstellungen',
  general: 'Allgemein',
  generalSettings: 'Allgemeine Einstellungen',
  generalSettingsLoginRequired: 'Allgemeine Einstellungen sind nur verfügbar, wenn du angemeldet bist.',
  showSensitive: 'Sensible Inhalte standardmäßig anzeigen',
  showAllSpoilers: 'Inhaltswarnungen standardmäßig ausklappen',
  showPlain: 'Eine graue Fläche für sensible Inhalte anzeigen',
  allSensitive: 'Alle Medien als sensibel behandeln',
  largeMedia: 'Große eingebettete Bilder und Videos anzeigen',
  autoplayGifs: 'Animierte Gifs automatisch abspielen',
  hideCards: 'Linkvorschauen verbergen',
  underlineLinks: 'Links in Beiträge und Profilen unterstreichen',
  accessibility: 'Barrierefreiheit',
  reduceMotion: 'Bewegung in Animationen der Oberfläche reduzieren',
  disableTappable: 'Berührungsempfindlichkeit auf ganzem Beitrag deaktivieren',
  removeEmoji: 'Emoji aus Anzeigenamen der Benutzer entfernen',
  shortAria: 'Verkürzte aria-label für Artikel verwenden',
  announceCardDescriptionsPre: 'Link-Vorschau-',
  announceCardDescriptionsText: 'Beschreibungen',
  announceCardDescriptionsDescription: 'Der Titel einer Link-Vorschau wird immer von Screenreadern angesagt. Aktiviere dies, um auch den Beschreibungstext darunter einzubeziehen.',
  announceCardDescriptionsPost: 'ansagen',
  theme: 'Design',
  themeForInstance: 'Design für {instance}',
  disableCustomScrollbars: 'Angepasste Rollbalken deaktivieren',
  bottomNav: 'Navigationsleiste am unteren Bildschirmrand platzieren',
  centerNav: 'Navigationsleiste zentrieren',
  preferences: 'Vorlieben',
  hotkeySettings: 'Einstellungen für Tastenkürzel',
  disableHotkeys: 'Alle Tastenkürzel deaktivieren',
  leftRightArrows: 'Linke und rechte Pfeiltasten schalten den Fokus um anstatt der Spalten oder Medien',
  editProfile: 'Profil bearbeiten',
  editProfileDisplayName: 'Anzeigename',
  editProfileBio: 'Bio',
  editProfileFields: 'Profil-Metadaten',
  editProfileFieldName: 'Bezeichnung',
  editProfileFieldValue: 'Inhalt',
  editProfileChangeAvatar: 'Avatar ändern',
  guide: 'Anleitung',
  reload: 'Neu laden',
  disableFollowRequestCount: 'Anzahl der Followeranfragen verbergen',
  hideLongPosts: 'Lange Beiträge ohne Inhaltswarnung einklappen',
  longPostLengthLabel: 'Kürzungsschwelle (Zeichen)',
  // Wellness settings
  wellness: 'Wohlbefinden',
  wellnessDescription: `Die Einstellungen fürs Wohlbefinden dienen dazu, die süchtig machenden oder Angst induzierenden Aspekte von Social Media zu reduzieren.
    Nimm hier Einstellungen vor, die Dir gut tun.`,
  enableAll: 'Alle einschalten',
  metrics: 'Messungen',
  hideFollowerCount: 'Verbirg Anzahl Folgender (ab 10 gedeckelt)',
  hideReblogCount: 'Verbirg Anzahl der Boosts',
  hideReplyCount: 'Anzahl der Antworten verbergen',
  hideFavoriteCount: 'Verbirg Anzahl Favorisierungen',
  hideUnread: 'Verbirg Anzeige ungelesener Benachrichtigungen (z.B. den roten Punkt)',
  showAbsoluteTimestamps: 'Absolute Zeitstempel (z.B. "3. März") anstelle von relativen Zeitstempeln (z.B. "vor 5 Minuten") anzeigen',
  enableThreadPolling: 'Auto-Refresh-Button in Threads anzeigen',
  defaultUnlistedReplies: 'Antworten standardmäßig als "Nicht gelistet" markieren',
  defaultLocalOnly: 'Beiträge standardmäßig nur auf der lokalen Instanz posten',
  enableQuotePost: 'Auswahl zwischen Boost und Zitat beim Boosten anzeigen',
  boostOrQuote: 'Boosten oder Zitieren',
  localOnlyUnsupported: 'Deine Instanz unterstützt keine lokal-begrenzten Beiträge',
  editProfileChangeHeader: 'Header ändern',
  editProfileSave: 'Speichern',
  editProfileSaving: 'Speichern…',
  profileUpdated: 'Profil aktualisiert',
  ui: 'Benutzeroberfläche',
  language: 'Sprache',
  interfaceLanguage: 'Sprache der Oberfläche',
  grayscaleMode: 'Graustufenmodus',
  wellnessFooter: `Diese Einstellungen basieren zum Teil auf Richtlinien des
    <a rel="noopener" target="_blank" href="https://humanetech.com">Center for Humane Technology</a>.`,
  // This is a link: "You can filter or disable notifications in the _instance settings_"
  profileUpdateFailed: 'Profil konnte nicht aktualisiert werden: {error}',
  filterNotificationsPre: 'Du kannst die Einstellungen für Benachrichtigungen in den',
  filterNotificationsText: 'Instanzeinstellungen',
  filterNotificationsPost: 'anpassen.',
  // Custom tooltips, like "Disable _infinite scroll_", where you can click _infinite scroll_
  // to see a description. It's hard to properly internationalize, so we just break up the strings.
  disableInfiniteScrollPre: '',
  disableInfiniteScrollText: 'Unendliches Scrollen',
  disableInfiniteScrollDescription: 'Wenn unendliches Scrollen deaktiviert ist, erscheinen neue Beiträge nicht automatisch am unteren oder oberen Ende der zeitleiste. Stattdessen kannst Du weitere Inhalte durch dafür vorgesehene Schaltflächen nachladen.',
  disableInfiniteScrollPost: 'deaktivieren',
  // Instance settings
  loggedInAs: 'Eingeloggt als',
  homeTimelineFilters: 'Filter für Startzeitleiste',
  notificationFilters: 'Filter für Benachrichtigungen',
  osNotificationsHeading: 'Push-Benachrichtigungen',
  osNotificationsDescription: 'Werde auf diesem Gerät benachrichtigt, auch wenn Zocial geschlossen ist.',
  notifyOnThisDevice: 'OS-Push-Benachrichtigungen auf diesem Gerät aktivieren',
  notifyOnThisDevicePre: '',
  notifyOnThisDeviceTrigger: 'OS-Push-Benachrichtigungen',
  notifyOnThisDevicePost: 'auf diesem Gerät aktivieren',
  pushOneAccountPerDevice: 'OS-Push-Benachrichtigungen sind nur für einen Account pro Gerät möglich.',
  pushActiveForOtherAccount: 'Derzeit aktiv für {account}.',
  pushSwitchTitle: 'Push-Benachrichtigungen verschieben?',
  pushSwitchText: 'OS-Push-Benachrichtigungen sind auf einen Account pro Gerät begrenzt. Für {to} aktivieren und für {from} deaktivieren?',
  pushSwitchConfirm: 'Verschieben',
  pushMovedToast: 'Push-Benachrichtigungen zu {to} verschoben — {from} benachrichtigt auf diesem Gerät nicht mehr.',
  deviceNotificationsForegroundOnly: 'Dieser Server unterstützt keine Hintergrund-Benachrichtigungen, daher wirst du nur benachrichtigt, solange Zocial in diesem Tab geöffnet ist.',
  inAppNotificationsHeading: 'In-App-Benachrichtigungen',
  inAppNotificationsDescription: 'Welche Aktivität im Benachrichtigungs-Tab erscheint.',
  notificationSoundHeading: 'Benachrichtigungstöne',
  notificationSoundDescription: 'Einen Ton abspielen, wenn eine neue Benachrichtigung eingeht.',
  notificationSounds: 'Benachrichtigungstöne',
  osNotificationsPromptTitle: 'Benachrichtigungen auf diesem Gerät aktivieren?',
  osNotificationsPromptText: 'Erhalte Desktop- oder Push-Benachrichtigungen auf diesem Gerät, wenn etwas passiert. Du kannst das jederzeit in den Einstellungen ändern. In-App-Benachrichtigungen bleiben so oder so aktiv.',
  enableNotifications: 'Aktivieren',
  notNow: 'Jetzt nicht',
  enableDesktopNotifications: 'Desktop-Benachrichtigungen aktivieren',
  desktopNotificationsNotSupported: 'Dein Browser unterstützt keine Desktop-Benachrichtigungen.',
  desktopNotificationsBlocked: 'Desktop-Benachrichtigungen sind blockiert. Bitte erlaube sie in Deinen Browser- oder Systemeinstellungen.',
  desktopNotificationTitle: 'Zocial',
  desktopNotificationBody: `{count, plural, one {eine neue Benachrichtigung} other {{count} neue Benachrichtigungen}}`,
  followedHashtags: 'Gefolgten Hashtags',
  noFollowedHashtags: 'Du folgst keinen Hashtags.',
  addHashtag: 'Hashtag folgen',
  pushNotifications: 'Push-Benachrichtigungen',
  // Add instance page
  storageError: 'Es sieht so aus als ob Zocial lokal keine Daten speichern kann. Ist Dein Browser im privaten Modus oder blockiert Cookies? Zocial speichert alle Daten lokal und braucht zum ordnungsgemäßen Betrieb LocalStorage und IndexedDB.',
  javaScriptError: 'Du musst JavaScript aktivieren, um dich anzumelden.',
  enterInstanceName: 'Namen der Instanz eingeben',
  instanceColon: 'Instanz:',
  // Custom tooltip, concatenated together
  getAnInstancePre: 'Hast Du noch keine',
  getAnInstanceText: 'instanz',
  getAnInstanceDescription: 'Eine Instanz ist Deine Heimat auf Mastodon, wie z.B. mastodon.social oder cybre.space.',
  getAnInstancePost: '?',
  joinMastodon: 'Tritt Mastodon bei!',
  instancesYouveLoggedInTo: 'Instanzen, in denen Du angemeldet bist:',
  addAnotherInstance: 'Eine weitere Instanz hinzufügen',
  youreNotLoggedIn: 'Du bist bei keiner Instanz angemeldet.',
  currentInstanceLabel: `{instance} {current, select,
    true {(jetzige Instanz)}
    other {}
  }`,
  // Link text
  logInToAnInstancePre: '',
  logInToAnInstanceText: 'Melde Dich bei einer Instanz an',
  logInToAnInstancePost: 'um Zocial zu verwenden.',
  // Another custom tooltip
  showRingPre: 'Immer einen',
  showRingText: 'Fokusring',
  showRingDescription: 'Der Fokusring ist der Rahmen, der um das fokussierte Element angezeigt wird, wenn Du mit der Tastatur navigierst. Standardmäßig wird er nicht angezeigt, wenn Du die maus oder einen Touchscreen verwendest. Hier kannst du einstellen, dass er immer angezeigt wird.',
  showRingPost: 'anzeigen',
  instances: 'Instanzen',
  addInstance: 'Instanz hinzufügen',
  homeTimelineFilterSettings: 'Einstellungen für die Filterung der Startzeitleiste',
  showReblogs: 'Boosts zeigen',
  showReplies: 'Antworten zeigen',
  switchOrLogOut: 'Zu dieser Instanz wechseln oder sich von ihr abmelden',
  switchTo: 'Zu dieser Instanz wechseln',
  switchToInstance: 'Zu Instanz wechseln',
  switchToNameOfInstance: 'Wechsle zu {instance}',
  logOut: 'Abmelden',
  logOutOfInstanceConfirm: 'Von {instance} abmelden?',
  notificationFilterSettings: 'Einstellungen für die Filterung von Benachrichtigungen',
  // Push notifications
  browserDoesNotSupportPush: 'Dein Browser unterstützt keine Push-Benachrichtigungen.',
  deniedPush: 'Du hast es abgelehnt, Push-Benachrichtigungen anzuzeigen.',
  pushSettings: 'Einstellungen für Push-Benachrichtigungen',
  newFollowers: 'Neue Folgende',
  reblogs: 'Boosts',
  pollResults: 'Umfrageergebnisse',
  needToReauthenticate: 'Du musst Dich neu anmelden, um die Push-Benachrichtigung einschalten zu können. Jetzt von {instance} abmelden?',
  failedToUpdatePush: 'Fehler beim Aktualisieren der Einstellungen für Push-Benachrichtigungen: {error}',
  // Themes
  chooseTheme: 'Wähle ein Design',
  darkBackground: 'Dunkler Hintergrund',
  lightBackground: 'Heller Hintergrund',
  themeLabel: `{label} {default, select,
    true {(Standard)}
    other {}
  }`,
  animatedImage: 'Animiertes Gif: {description}',
  showImage: `Zeige {animated, select,
    true {animiert}
    other {}
  } image: {description}`,
  playVideoOrAudio: `Wiedergabe von {audio, select,
    true {audio}
    other {video}
  }: {description}`,
  accountFollowedYou: '{name} folgt Dir jetzt, {account}',
  accountSignedUp: '{name} hat sich angemeldet, {account}',
  accountRequestedFollow: '{name} hat angefragt, dir zu folgen, {account}',
  accountReported: '{name} hat einen Bericht eingereicht, {account}',
  unhandledNotification: 'Unbekannter Benachrichtigungstyp {type}',
  reblogCountsHidden: 'Anzahl Boosts verborgen',
  favoriteCountsHidden: 'Anzahl Favorisierungen verborgen',
  rebloggedTimes: `Geboostet {count, plural,
    one {einmal}
    other {{count} mal}
  }`,
  favoritedTimes: `Favorisiert {count, plural,
    one {einmal}
    other {{count} mal}
  }`,
  reactedTimes: `Reagiert {count, plural,
    one {1 Mal}
    other {{count} Mal}
  }`,
  pinnedStatus: 'Angehefteter Beitrag',
  rebloggedYou: 'hat Deinen Beitrag geboostet',
  favoritedYou: 'hat Deinen Beitrag favorisiert',
  reacted: 'hat mit einem Emoji reagiert',
  reactedWith: 'reagierte mit',
  followedYou: 'folgt Dir jetzt',
  edited: 'hat seinen Beitrag bearbeitet',
  requestedFollow: 'hat angefragt, dir zu folgen',
  reported: 'hat einen Bericht eingereicht',
  signedUp: 'hat sich angemeldet',
  pollYouCreatedEnded: 'Eine von Dir erstellte Umfrage ist beendet',
  pollYouVotedEnded: 'Eine Umfrage, an der Du teilgenommen hast, ist beendet',
  reblogged: 'geboostet',
  // Präsens-Verben nur für den Beitrags-Header ("{account} boostet/antwortet an {target}").
  // Getrennt von `reblogged` (Bestätigungs-Ansage „Geboostet") und `replyToLower`
  // (Substantiv im Boost-einer-Antwort-Fall „boostet Antwort an …").
  boostsAction: 'boostet',
  repliesTo: 'antwortet an',
  startedThread: 'beginnt einen Thread',
  showSensitiveMedia: 'Sensible Inhalte zeigen',
  hideSensitiveMedia: 'Sensible Inhalte verbergen',
  clickToShowSensitive: 'Sensible Inhalte. Klicke zum Anzeigen.',
  unreblogged: 'Boost aufgehoben',
  unfavorited: 'Favorit entfernt',
  translateStatus: 'Beitrag übersetzen',
  translated: `Übersetzter Beitrag von {from}{detected, select, true { - Erkannt} other {}}`,
  translation: 'Übersetzung',
  translationTargetLanguage: 'Übersetzungssprache',
translationBrowserDefault: 'Browser-Standard',
translationLanguageUnavailable: 'Sprachliste nicht verfügbar – Übersetzungssprache folgt Browser-Standard',
translateError: 'Beim Übersetzen dieses Beitrags ist ein Fehler aufgetreten',
  longPost: 'Langer Beitrag',
  longPostLengthLabel: 'Kürzungsschwelle (Zeichen)',
  // Accessible status labels
  accountRebloggedYou: '{account} hat Deinen Beitrag geboostet',
  accountFavoritedYou: '{account} hat Deinen Beitrag favorisiert',
  contentWarningContent: 'Inhaltswarnung: {spoiler}',
  hasMedia: 'hat Medien',
  accountEdited: '{account} hat seinen Beitrag bearbeitet',
  hasPoll: 'hat Umfrage',
  shortStatusLabel: '{privacy} Beitrag von {account}',
  // Privacy types
  public: 'Öffentlich',
  unlisted: 'Nicht gelistet',
  followersOnly: 'Nur Folgende',
  direct: 'Direkt',
  // Themes
  themeRoyal: 'Light',
  themeScarlet: 'Scarlet',
  themeSeafoam: 'Seafoam',
  themeHotpants: 'Hotpants',
  themeOaken: 'Oaken',
  themeMajesty: 'Majesty',
  themeGecko: 'Gecko',
  themeGrayscale: 'Grayscale',
  themeZocial: 'Zocial',
  themeOzark: 'Ozark',
  themeCobalt: 'Cobalt',
  themeSorcery: 'Sorcery',
  themePunk: 'Punk',
  themeRiot: 'Riot',
  themeEmber: 'Ember',
  themeHacker: 'Hacker',
  themeMastodon: 'Mastodon',
  themePitchBlack: 'Pitch Black',
  themeDarkGrayscale: 'Dark Grayscale',
  // Polls
  voteOnPoll: 'In dieser Umfrage abstimmen',
  pollChoices: 'Auswahlmöglichkeiten',
  vote: 'Abstimmen',
  pollDetails: 'Einzelheiten zur Umfrage',
  refresh: 'Aktualisieren',
  expires: 'Endet',
  expired: 'Beendet',
  voteCount: `{count, plural,
    one {eine Stimme}
    other {{count} Stimmen}
  }`,
  // Status interactions
  clickToShowThread: '{time} - Klicke, um Unterhaltung anzuzeigen',
  showMore: 'Zeige mehr',
  showLess: 'Zeige weniger',
  closeReply: 'Antwort schließen',
  reactToStatus: 'Auf Beitrag reagieren',
  cannotReblogFollowersOnly: 'Kann nicht geboostet werden, da nur Folgende',
  cannotReblogDirectMessage: 'Kann nicht geboostet werden, da dies eine Direktnachricht ist',
  reblog: 'Boost',
  reply: 'Antworten',
  replyTo: 'Antwort an',
  replyToLower: 'Antwort an',
  replyToThread: 'Auf Unterhaltung antworten',
  favorite: 'Favorisieren',
  unfavorite: 'Favorisieren aufheben',
  // timeline
  loadingMore: 'Lade weitere',
  loadMore: 'Lade weitere',
  showCountMore: 'Zeige {count} weitere',
  nothingToShow: 'Nichts zum anzeigen.',
  couldNotLoadAccounts: 'Diese Liste konnte nicht geladen werden. Prüfe deine Verbindung und versuche es erneut.',
  accountListUnavailable: 'Diese Liste ist hier nicht verfügbar – das Profil hält sie evtl. privat, oder dein Server kennt sie nicht.',
  accountListPartial: 'Zeige {shown} von {total} – den Rest liefert dein Server nicht.',
  // status thread page
  statusThreadPage: 'Seite für Beitrag-Unterhaltung',
  status: 'Beitrag',
  // toast messages
  blockedAccount: 'Account blockiert',
  unblockedAccount: 'Blockade des Accounts aufgehoben',
  unableToBlock: 'Konnte Account nicht blockieren: {error}',
  unableToUnblock: 'Konnte Blockade des Accounts nicht aufheben: {error}',
  bookmarkedStatus: 'Beitrag als Lesezeichen gespeichert',
  unbookmarkedStatus: 'Beitrag aus Lesezeichen entfernt',
  unableToBookmark: 'Konnte kein lesezeichen setzen: {error}',
  unableToUnbookmark: 'Konnte Lesezeichen nicht entfernen: {error}',
  cannotPostOffline: 'Du kannst nicht senden, wenn Du offline bist',
  cannotPostEmpty: 'Schreibe etwas oder füge Medien hinzu, bevor du etwas postest.',
  pollNeedsTwoOptions: 'Gib deiner Umfrage mindestens zwei nicht-leere Optionen.',
  unableToPost: 'Konnte Beitrag nicht posten: {error}',
  statusDeleted: 'Beitrag gelöscht',
  unableToDelete: 'Konnte Beitrag nicht löschen: {error}',
  cannotFavoriteOffline: 'Du kannst nicht favorisieren, wenn Du offline bist',
  cannotUnfavoriteOffline: 'Du kannst Favorisierung nicht zurücknehmen, wenn Du offline bist',
  // Custom emoji reactions
  cannotReactWithRemoteEmoji: 'Deine Instanz erlaubt keine Reaktionen mit fremden benutzerdefinierten Emojis',
  tooManyMediaAttachments: 'Es sind nur {max} Medienanhänge erlaubt',
  // Instance login errors
  alreadyLoggedInTo: 'Du bist bereits bei {instance} angemeldet',
  areYouOffline: 'Bist Du offline?',
  invalidOauthState: 'Ungültiger OAuth-State — bitte starte die Anmeldung erneut',
  failedToConnectToInstance: '{error}. Verbindung zur Instanz fehlgeschlagen.',
  instanceGenericError: `Ist das eine gültige Instanz? Blockiert eine Browser-Erweiterung die Anfrage? Bist Du im privaten Modus? Falls Du glaubst, dass dies ein Problem mit Deiner Instanz ist, sende bitte <a href="https://git.ztfr.eu/Dome/Zocial/src/branch/main/docs/Admin-Guide.md" target="_blank" rel="noopener">diesen Link</a> an die Administration Deiner Instanz.`,
  unableToFavorite: 'Konnte nicht favorisieren: {error}',
  unableToUnfavorite: 'Konnte Favorisierung nicht aufheben: {error}',
  followedAccount: 'folge jetzt diesem Account',
  unfollowedAccount: 'Folge diesem Account nicht mehr',
  removeFollowerAccount: '{account} aus Followern entfernen',
  removeFollowerTitle: 'Follower entfernen?',
  removeFollowerText: '{account} aus deinen Followern entfernen? Das kannst du nicht selbst rückgängig machen – nur die Person kann dir wieder folgen.',
  removeFollowerConfirm: 'Entfernen',
  removedFollower: 'Aus deinen Followern entfernt',
  removeFromFollowersNotSupported: 'Dieser Server unterstützt das Entfernen von Followern nicht.',
  unableToFollow: 'Konnte dem Account nicht folgen: {error}',
  unableToUnfollow: 'Konnte den Account nicht entfolgen: {error}',
  accessTokenRevoked: 'Das Zugriffstoken wurde zurückgezogen, von {instance} abgemeldet',
  loggedOutOfInstance: 'Von {instance} abgemeldet',
  failedToUploadMedia: 'Konnte Medien nicht hochladen: {error}',
  mutedAccount: 'Account stummgeschaltet',
  unmutedAccount: 'Stummschaltung von Account aufgehoben',
  unableToMute: 'Konnte Account nicht stummschalten: {error}',
  unableToUnmute: 'Konnte Stummschaltung von Account nicht aufheben: {error}',
  mutedConversation: 'Unterhaltung stummgeschaltet',
  unmutedConversation: 'Stummschaltung der Unterhaltung aufgehoben',
  unableToMuteConversation: 'Konnte Unterhaltung nicht stummschalten: {error}',
  unableToUnmuteConversation: 'Konnte Stummschaltung der Unterhaltung nicht aufheben: {error}',
  unpinnedStatus: 'Beitrag abgeheftet',
  unableToPinStatus: 'Konnte Beitrag nicht anheften: {error}',
  unableToUnpinStatus: 'Konnte Beitrag nicht abheften: {error}',
  unableToRefreshPoll: 'Konnte Umfrage nicht aktualisieren: {error}',
  unableToVoteInPoll: 'Konte in der Umfrage nicht abstimmen: {error}',
  cannotReblogOffline: 'Du kannst nicht boosten, wenn Du offline bist.',
  cannotUnreblogOffline: 'Du kannst einen Boost nicht aufheben, wenn Du offline bist.',
  failedToReblog: 'Boosten fehlgeschlagen: {error}',
  failedToUnreblog: 'Aufheben des Boosts fehlgeschlagen: {error}',
  submittedReport: 'Meldung übermittelt',
  failedToReport: 'Übermittlung der Meldung fehlgeschlagen: {error}',
  approvedFollowRequest: 'Folgeanfrage genehmigt',
  rejectedFollowRequest: 'Folgeanfrage abgelehnt',
  unableToApproveFollowRequest: 'Konnte Folgeanfrage nicht genehmigen: {error}',
  unableToRejectFollowRequest: 'Konnte Folgeanfrage nicht ablehnen: {error}',
  searchError: 'Fehler bei der Suche: {error}',
  hidDomain: 'Domain verborgen',
  unhidDomain: 'Domain nicht mehr verborgen',
  unableToHideDomain: 'Konnte Domain nicht verbergen: {error}',
  unableToUnhideDomain: 'Konnte Verbergen der Domain nicht aufheben: {error}',
  showingReblogs: 'Zeige Boosts an',
  hidingReblogs: 'Verberge Boosts',
  unableToShowReblogs: 'Kann Boosts nicht anzeigen: {error}',
  unableToHideReblogs: 'Kann Boosts nicht verbergen: {error}',
  unableToShare: 'Teilen fehlgeschlagen: {error}',
  unableToSubscribe: 'Abonnieren fehlgeschlagen: {error}',
  showingOfflineContent: 'Anforderung übers Internet fehlgeschlagen. Zeige Offline-Inhalte an.',
  youAreOffline: 'Du scheinst keine Verbindung zum Internet zu haben. Du kanst weiterhin Beiträge lesen, solange Du offline bist.',
  // Snackbar UI
  updateAvailable: 'Update der App verfügbar',
  // Details
  statusEdited: 'Bearbeitet',

  // --- Vervollständigung 2026-06-15: zuvor fehlende Keys (fielen auf Englisch zurück) ---
  // Übersetzung
  translationBrowserDefault: 'Browser-Standard',
  translationLanguageUnavailable: 'Sprachliste nicht verfügbar – Übersetzungssprache folgt dem Browser-Standard',
  translateError: 'Beim Übersetzen dieses Beitrags ist ein Fehler aufgetreten',
  translateRateLimit: 'Du hast das Limit für Übersetzungen erreicht',
  translateUnsupportedLanguage: 'Diese Sprache wird derzeit nicht unterstützt',
  alreadyInTargetLanguage: 'Beitrag ist bereits in deiner Sprache',
  translating: 'Wird übersetzt...',
  hideTranslation: 'Übersetzung ausblenden',
  // Beitrag / Zitate
  quoteStatus: 'Beitrag zitieren',
  rebloggedByAccount: '{account} hat {original} geboostet',
  // Profil-Statistik
  postingStatsOriginalTitle: '{count, plural, one {# Originalbeitrag} other {# Originalbeiträge}} ({percent})',
  postingStatsRepliesTitle: '{count, plural, one {# Antwort} other {# Antworten}} ({percent})',
  postingStatsBoostsTitle: '{count, plural, one {# Boost} other {# Boosts}} ({percent})',
  // Follow / Abonnements
  requestingLabel: 'Wird angefragt...',
  subscribedAccount: 'Konto abonniert',
  unsubscribedAccount: 'Konto nicht mehr abonniert',
  unableToUnsubscribe: 'Abbestellen fehlgeschlagen: {error}',
  subscriptions: 'Abonnierte Beiträge',
  // Logs
  clearLogs: 'Logs löschen',
  clearLogsConfirm: 'Alle Logs löschen? Dies kann nicht rückgängig gemacht werden.',
  logsCleared: 'Logs gelöscht',
  // Thread / Einstellungen
  threadPollingStart: 'Antworten automatisch aktualisieren (alle 30 s)',
  threadPollingStop: 'Automatische Aktualisierung stoppen',
  disableNotificationSound: 'Benachrichtigungstöne deaktivieren',
  immediacy: 'Unmittelbarkeit',
  composer: 'Verfassen',
  filterNotificationsTextSingle: 'Kontoeinstellungen',
  // Aktions-Texte im Beitrags-Header
  moved: 'umgezogen nach',
  bite: 'hat dich gebissen',
  posted: 'gepostet',
  favorited: 'favorisiert',
  reactionCountsHidden: 'Reaktionsanzahl ausgeblendet',
  // Themes (Eigennamen, wie die übrigen nicht übersetzt)
  themeTangerine: 'Tangerine',
  themeCohostLight: 'Cohost Light',
  // Wortfilter
  wordFilters: 'Wortfilter',
  noFilters: 'Du hast keine Wortfilter.',
  wordOrPhrase: 'Wort oder Ausdruck',
  contexts: 'Kontexte',
  addFilter: 'Filter hinzufügen',
  addWordFilter: 'Wortfilter hinzufügen',
  editFilter: 'Filter bearbeiten',
  filterHome: 'Startseite und Listen',
  filterNotifications: 'Benachrichtigungen',
  filterPublic: 'Öffentliche Zeitleisten',
  filterThread: 'Unterhaltungen',
  filterAccount: 'Profile',
  filterUnknown: 'Unbekannt',
  expireAfter: 'Ablaufen nach',
  whereToFilter: 'Wo filtern',
  irreversible: 'Unwiderruflich',
  wholeWord: 'Ganzes Wort',
  save: 'Speichern',
  updatedFilter: 'Filter aktualisiert',
  createdFilter: 'Filter erstellt',
  failedToModifyFilter: 'Filter konnte nicht geändert werden: {error}',
  dropFiltersNotSupported: 'Dieser Server unterstützt keine unwiderruflichen (verwerfenden) Filter. Lass „Unwiderruflich“ deaktiviert, um passende Beiträge stattdessen hinter einer Warnung zu verbergen.',
  deletedFilter: 'Filter gelöscht',
  required: 'Erforderlich',
  // Dialog- / Menü-Titel (aria)
  profileOptions: 'Profiloptionen',
  statusOptions: 'Beitragsoptionen',
  copyLink: 'Link kopieren',
  copy: 'Kopieren',
  emoji: 'Emoji',
  editMedia: 'Medien bearbeiten',
  shortcutHelp: 'Tastenkürzel-Hilfe',
  confirm: 'Bestätigen',
  closeDialog: 'Dialog schließen',
  postPrivacy: 'Sichtbarkeit des Beitrags',
  localOnly: 'Nur lokal',
  contentType: 'Inhaltstyp',
  contentTypeLabel: 'Inhaltstyp ändern (aktuell {label})',
  // Seitentitel / Timeline-Header (aria)
  homeOnInstance: 'Startseite auf {instance}',
  statusesTimelineOnInstance: 'Beiträge: {timeline}-Zeitleiste auf {instance}',
  statusesHashtag: 'Beiträge: #{hashtag}-Hashtag',
  statusesThread: 'Beiträge: Thread',
  statusesAccountTimeline: 'Beiträge: Konto-Zeitleiste',
  statusesList: 'Beiträge: Liste',
  notificationsOnInstance: 'Benachrichtigungen auf {instance}',
  // Compose-Header (Bearbeiten/Antworten/Zitieren) + Umfrage-Option
  editing: 'Bearbeite',
  replyingTo: 'Antwort auf',
  quoting: 'Zitiere',
  aPost: 'einen Beitrag',
  aPostBy: 'einen Beitrag von {handle}',
  dontEdit: 'Nicht bearbeiten',
  dontReply: 'Nicht antworten',
  dontQuote: 'Nicht zitieren',
  addPollChoice: 'Antwortoption hinzufügen',
  postsAndReplies: 'Beiträge und Antworten'
}
